import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from "../api.js";
import { toast } from 'react-toastify';

export const GetVendorListSlice = createAsyncThunk("admin/vendor-list",async (params, { rejectWithValue }) => {
    try {
      const response = await api.GetVendorListApi(params);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const GetVendorDetailSlice = createAsyncThunk("admin/vendor-detail/id",async (id, { rejectWithValue }) => {
    try {
      const response = await api.GetVendorDetailApi(id);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

export const CreateVendorSlice = createAsyncThunk('admin/vendor-insert',async (data, { rejectWithValue }) => {
  try {
    const response = await api.CreateVendorApi(data);
      return response.data;
    } catch (error) {
    console.error("API error:", error);
    return rejectWithValue(error.response?.data || { message: "An error occurred" });
  }
}
);

export const UpdateVendorSlice = createAsyncThunk('admin/vendor-update/id',async (data, { rejectWithValue }) => {
  try {
    const response = await api.UpdateVendorApi(data);
      return response.data;
    } catch (error) {
    console.error("API error:", error);
    return rejectWithValue(error.response?.data || { message: "An error occurred" });
  }
}
);

export const DeleteVendorSlice = createAsyncThunk('admin/vendor-delete/id',async (id, { rejectWithValue }) => {
  try {
    const response = await api.DeleteVendorApi(id);
      return response.data;
    } catch (error) {
    console.error("API error:", error);
    return rejectWithValue(error.response?.data || { message: "An error occurred" });
  }
}
);

const VendorManagementSlice = createSlice({
  name: 'VendorManagement',
  initialState: {
    VendorList: [],
    VendorDetail: null,
    createdVendor: [],
    updatedVendor: [],
    deletedVendor: [],
    loading: false,
    error: null,
    validationErrors: [],
  },
  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null;
      state.validationErrors = [];
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || [];
    }

    builder
      .addCase(GetVendorListSlice.pending,handlePendingState)
      .addCase(GetVendorListSlice.fulfilled, (state, action) => {
        state.VendorList = action.payload.data;
        state.loading = false;
      })
      .addCase(GetVendorListSlice.rejected,handleRejectState)

      .addCase(GetVendorDetailSlice.pending,handlePendingState)
      .addCase(GetVendorDetailSlice.fulfilled, (state, action) => {
        state.VendorDetail = action.payload.data;
        state.loading = false;
      })
      .addCase(GetVendorDetailSlice.rejected,handleRejectState)

      .addCase(CreateVendorSlice.pending,handlePendingState)
      .addCase(CreateVendorSlice.fulfilled, (state, action) => {
        state.createdVendor = action.payload.data;
        state.loading = false;
        toast.success("Vendor added successfully!");
      })
      .addCase(CreateVendorSlice.rejected,handleRejectState)

      .addCase(UpdateVendorSlice.pending,handlePendingState)
      .addCase(UpdateVendorSlice.fulfilled, (state, action) => {
        state.updatedVendor = action.payload.data;
        state.loading = false;
        toast.success("Vendor updated successfully!");
      })
      .addCase(UpdateVendorSlice.rejected,handleRejectState)

      .addCase(DeleteVendorSlice.pending,handlePendingState)
      .addCase(DeleteVendorSlice.fulfilled, (state, action) => {
        state.deletedVendor = action.payload.data;
        state.loading = false;
        toast.success("Vendor deleted successfully!");
      })
      .addCase(DeleteVendorSlice.rejected,handleRejectState);
  },
});

export default VendorManagementSlice.reducer;
